import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TokenService } from './services/token/token.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [TokenService],
})
export class CoreModule {}
